import { render, staticRenderFns } from "./HuaxianFinanceProjectDetail.vue?vue&type=template&id=fa576ed0&scoped=true&"
import script from "./HuaxianFinanceProjectDetail.vue?vue&type=script&lang=js&"
export * from "./HuaxianFinanceProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianFinanceProjectDetail.vue?vue&type=style&index=0&id=fa576ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa576ed0",
  null
  
)

export default component.exports